<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <Caption label="Devil App Builder[스몰 코딩 플랫폼]" />

        <div class="desc">
          네이티브 모바일 앱을 쉽게 만들고 운영할 수 있는 클라우드 플랫폼입니다
        </div>

        <div class="link">
          <a href="https://www.devil-app-builder.com/" target="_blank">www.devil-app-builder.com</a>
        </div>
        
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
import SectionTechItem from "./SectionTechItem.vue";
export default {
  components: {
    Caption,
    SectionTechItem,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 100px 20px 100px 20px;
}

.title_box {
  width: 272px;
}
ul {
  margin-bottom: 80px;
  width: 100%;
  justify-content: space-between;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

ul li {
  margin-top: 50px;
  display: inline-block;
}

.link {
  margin-top: 20px;
  font-weight: 300;
  font-size: 20px;
  color: #000000;
}

.desc {
  margin-top: 50px;
  font-weight: 300;
  font-size: 20px;
  color: #000000;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 100px 20px 100px 20px;
  }

  .title_box {
    width: 272px;
  }
  ul {
    margin-bottom: 80px;
    width: 100%;
    list-style-type: none;
    display: block;
    text-align: center;
  }

  ul li {
    margin-top: 50px;
    width: fit-content;
    display: block;
    text-align: center;
  }
}
</style>
  